module.exports = __webpack_public_path__ + "img/tappy-big-red.54a5985d.svg";